import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { CustomerDetails } from './pages/CustomerDetails';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { AuthProvider } from './context/AuthContext';
import { CustomerProvider } from './context/CustomerContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { configureAmplify } from './config/amplify-config';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Initialize Amplify with the proper configuration
configureAmplify();

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      
      <Router>
        <AuthProvider>
          <CustomerProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              
              {/* Protected Routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/customer-details/:customerId" element={
                <ProtectedRoute>
                  <CustomerDetails />
                </ProtectedRoute>
              } />
              
              {/* Catch all route - redirect to dashboard if authenticated, otherwise to login */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </CustomerProvider>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;
